export default {
  title: 'OFFER SETTINGS',
  items: {
    ProviderOfferDistanceForASAP: {
      label: 'Provider Offer Distance for ASAP',
      type: 'integer',
      unit: 'miles'
    },
    MaxOffersForASAP: {
      label: 'Max Offers for ASAP',
      type: 'integer',
      unit: 'offers'
    },
    ProviderOfferDistanceForRSVP: {
      label: 'Provider Offer Distance for RSVP',
      type: 'integer',
      unit: 'miles'
    },
    MaxOffersForRSVP: {
      label: 'Max Offers for RSVP',
      type: 'integer',
      unit: 'offers'
    },
    DriverConfirmationTimeBuffer: {
      label: 'Driver Confirmation Time Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    DriverConfirmationTimeOut: {
      label: 'Driver Confirmation Timeout',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/offer-settings.js